module.exports = __webpack_public_path__ + "662b0e22db7a641ae05cd019e3fafe78.svg";


//////////////////
// WEBPACK FOOTER
// ./client/views/WizardView/images/sidemenu_placeholder.svg?external
// module id = 2167
// module chunks = 0